import React from 'react';

interface SearchHighlightProps {
	text: string;
	keyword: string;
}

export const SearchHighlight = ({ text, keyword }: SearchHighlightProps) => {
	// eslint-disable-next-line react/jsx-no-useless-fragment
	if (!keyword)
		return <span className="wrap-anywhere hyphens-auto">{text}</span>;

	const regex = new RegExp(`(${keyword})`, 'gi');
	const parts = text.split(regex);

	return (
		<>
			{parts.map((part, idx) =>
				part.toLowerCase() === keyword.toLowerCase() ? (
					<span
						// eslint-disable-next-line react/no-array-index-key
						key={idx}
						className="font-bold wrap-anywhere hyphens-auto">
						{part}
					</span>
				) : (
					// eslint-disable-next-line react/no-array-index-key
					<span
						key={idx}
						className="wrap-anywhere hyphens-auto">
						{part}
					</span>
				)
			)}
		</>
	);
};
